// extracted by mini-css-extract-plugin
export default {"variantIcon":"variant-icon__pnNQaDML"};